import { getTableMetrics } from '../services';
export const fetchEditColumnsData = (preset) => getTableMetrics(preset).then(response => formatResponse(response?.data));
const formatResponse = (response) => ({
    success: response?.success,
    errors: response?.errors,
    tableMetrics: Object.keys(response?.table_metrics || {}).map(metricKey => ({
        key: metricKey,
        data: [...response?.table_metrics[metricKey]].map(item => ({
            key: item?.key,
            name: item?.name,
            type: item?.type,
            preview: item?.preview,
        })),
    })),
    ordering: response?.ordering,
    warnings: response?.warnings,
});
